<template>
    <el-dialog ref="modal-comprehensive-business" title="综合业务" z-index="1051"
               @reset="handleComprehensiveBusinessClose" @close="handleComprehensiveBusinessClose"
               :visible.sync=comprehensiveBusinessDialogVisible  width="75%" :close-on-click-modal=false append-to-body hide-footer>
        <el-form @submit="handleComprehensiveBusinessSubmit" @reset="handleComprehensiveBusinessClose" ref="form"
                 label-position="top">
            <el-form-item id='businessType' label="选择业务" label-position=“top” class="ml-0">
                <el-checkbox value="2" v-model="isChooseOutdoor">出门证</el-checkbox>
                <el-checkbox value="3" v-model="isChooseTransport">运输申请</el-checkbox>
                <el-checkbox value="5" v-model="isChooseDelivery">转交申请</el-checkbox>
                <el-checkbox value="7" v-model="isChooseTransferTicket" v-if="isFromOrder">转出(入)票</el-checkbox>
            </el-form-item>

            <el-form-item id='commonData' label="通用数据" label-position=“top”
                          v-if="comprehensiveBusinessDialogVisible && (isChooseOutdoor || isChooseDelivery || isChooseTransport) ">
                <el-form-item v-if="!isFromOrder">
                    <el-row>
                        <div class="d-flex flex-row">
                            <el-col >
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.projectCode"
                                            placeholder="项目号" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.projectName"
                                            placeholder="项目名" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col >
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.network"
                                            placeholder="network号" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col >
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.wbsNumber"
                                            placeholder="wbs号" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col >
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.prNumber"
                                            placeholder="pr号" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row>
                        <div class="d-flex flex-row">
                            <el-col>
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.orderCode"
                                            placeholder="工单号" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.operationSeq"
                                            placeholder="工序号" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col >
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.operationDescription"
                                            placeholder="工序描述" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col  v-if="!isChooseDelivery">
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.materialCode"
                                            placeholder="物料号" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col  v-if="!isChooseDelivery">
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.materialDesc"
                                            placeholder="物料描述" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row  v-if="!isChooseDelivery">
                        <div class="d-flex flex-row">
                            <el-col>
                                <el-form-item>
                                    <el-input-number
                                            v-model="comprehensiveCommonBusinessInfo.sithMesMatSizeAndWeightInfo.length"
                                            placeholder="长(mm)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col >
                                <el-form-item>
                                    <el-input-number
                                            v-model="comprehensiveCommonBusinessInfo.sithMesMatSizeAndWeightInfo.width"
                                            placeholder="宽(mm)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col >
                                <el-form-item>
                                    <el-input-number
                                            v-model="comprehensiveCommonBusinessInfo.sithMesMatSizeAndWeightInfo.height"
                                            placeholder="高(mm)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col >
                                <el-form-item>
                                    <el-input-number
                                            v-model="comprehensiveCommonBusinessInfo.sithMesMatSizeAndWeightInfo.weight"
                                            placeholder="重量(kg)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col >
                                <el-form-item>
                                    <el-input-number
                                            v-model="comprehensiveCommonBusinessInfo.sithMesMatSizeAndWeightInfo.quantity"
                                            placeholder="数量" size=mini></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col >
                                <el-form-item>
                                    <el-input
                                            v-model="comprehensiveCommonBusinessInfo.sithMesMatSizeAndWeightInfo.unit"
                                            placeholder="单位" size=mini></el-input>
                                </el-form-item>
                            </el-col>
                        </div>
                    </el-row>
                </el-form-item>

                <el-form-item v-for="(info, index) in selectedItemsDeepCopy" :key="index" v-if="isFromOrder">
                    <el-row>
                        <div class="d-flex flex-row">

                            <el-checkbox v-model="info.checked" @change="handleMatCheckboxChange(index,info)"
                                         size=mini>{{ info.orderCode }}选择顶级物料
                            </el-checkbox>
                            <el-form-item class="ml-auto" :rules="selectedComponents[index]" required>
                                <el-select placeholder="请选择物料" multiple filterable
                                           v-model="selectedComponents[index]" v-if="!info.checked"
                                           size=mini>
                                    <div class="select_up">
                                        <el-button type="text" @click="selectAll(info, index)">
                                            <i class="el-icon-circle-check" />
                                            全选</el-button>
                                        <el-button type="text" @click="removeAll(index)">
                                            <i class="el-icon-close" />
                                            清空</el-button>
                                        <el-button type="text" @click="selectReverse(info,index)">
                                            <i class="el-icon-copy-document" />
                                            反选</el-button>
                                    </div>
                                    <el-option
                                            v-for="(componentInfo,idx) in componentOptions[info.orderCode]"
                                            multiple :key="idx"
                                            :value="componentInfo" :label="componentInfo.label">
                                        {{ componentInfo.label }}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-row>
                    <slot v-if="info.checked">
                        <el-row>
                            <el-col :span=3>
                                <span>
                                    {{ info.materialCode }}
                                </span>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="topMatSizeAndWeightInfo[index].quantity"
                                            placeholder="数量" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input
                                            v-model="topMatSizeAndWeightInfo[index].unit"
                                            placeholder="单位" size=mini  @input="changeMessage"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="topMatSizeAndWeightInfo[index].length"
                                            placeholder="长(mm)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="topMatSizeAndWeightInfo[index].width"
                                            placeholder="宽(mm)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="topMatSizeAndWeightInfo[index].height"
                                            placeholder="高(mm)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="topMatSizeAndWeightInfo[index].area"
                                            placeholder="面积(mm2)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="topMatSizeAndWeightInfo[index].weight"
                                            placeholder="重量(kg)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </slot>
                    <slot v-if="!info.checked">
                        <el-row v-for="(item, idx) in selectedComponents[index]" :key="idx">
                            <el-col :span=3>
                                <span>
                                    {{ item.materialNumber }}
                                </span>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="item.sithMesMatSizeAndWeightInfo.quantity"
                                            placeholder="数量" size=mini aria-hidden="true"
                                            :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input
                                            v-model="item.sithMesMatSizeAndWeightInfo.unit"
                                            placeholder="单位" size=mini aria-hidden="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="item.sithMesMatSizeAndWeightInfo.length"
                                            placeholder="长(mm)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="item.sithMesMatSizeAndWeightInfo.width"
                                            placeholder="宽(mm)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="item.sithMesMatSizeAndWeightInfo.height"
                                            placeholder="高(mm)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="item.sithMesMatSizeAndWeightInfo.area"
                                            placeholder="面积(mm2)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span=3>
                                <el-form-item>
                                    <el-input-number
                                            v-model="item.sithMesMatSizeAndWeightInfo.weight"
                                            placeholder="重量(kg)" size=mini :controls="false"></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </slot>
                </el-form-item>
                <el-row>
                    <el-col :span=6>
                        <el-form-item :rules="[{ required: true, message: '请选择发货方', trigger: 'blur' }]">
                            <el-select filterable v-model="selectedConsignor"
                                       placeholder="请选择发货方" @change="handleConsignorChange"
                                       size=mini class="w-100">
                                <el-option
                                        v-for="(item,idx) in supplies"
                                        :key="idx"
                                        :label="item.chName"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.consignorContact"
                                      placeholder="请输入发货方联系人" size=mini @input="changeMessage"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.consignorContactPhone"
                                      placeholder="请输入发货人联系电话" size=mini @input="changeMessage"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.consignorAddress"
                                      placeholder="请输入发货人地址" size=mini  @input="changeMessage"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span=6>
                        <el-form-item>
                            <el-select filterable v-model="selectedConsignee" class="w-100"
                                       placeholder="请选择收货方" @change="handleConsigneeChange"
                                       size=mini>
                                <el-option
                                        v-for="(item,idx) in supplies"
                                        :key="idx"
                                        :label="item.chName"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>

                            <el-input v-model="comprehensiveBusinessRecordSaveForm.consigneeContact"
                                      placeholder="请输入收货方联系人" size=mini @input="changeMessage"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.consigneeContactPhone"
                                      placeholder="请输入收货方联系电话" size=mini @input="changeMessage"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.consigneeAddress"
                                      placeholder="请输入收货方地址" size=mini @input="changeMessage"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="出门证业务数据" v-if="isChooseOutdoor" label-position=“top”>
                <el-row>
                    <el-form-item v-for="(info,index) in selectedItems" v-if="isFromOrder">
                        <span>{{ info.orderCode }}  </span>
                        <el-select placeholder="请选择工序"
                                   v-model="selectedOperations[index]"
                                   class="el-customer-select"
                                   popper-class="popper-class"
                                   :popper-append-to-body="false"
                                   size=mini multiple filterable>
                            <el-option v-for="(operation,index) in operationOptions[info.id]" multiple="" :key="index"
                                       :value="operation.value"
                                       :label="operation.label">
                                {{ operation.label }}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span=6>
                        <el-form-item>
                            <el-select v-model="comprehensiveBusinessRecordSaveForm.outdoorType"
                                       placeholder="出门证类型"  size=mini class="w-100">
                                <el-option v-for="(item,idx) in outdoorTypeOptions" :key="idx" :value="item.value"
                                           :label="item.label">
                                    {{ item.label }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>
                            <el-select v-model="comprehensiveBusinessRecordSaveForm.category" class="w-100"
                                       placeholder="条目类别"  size=mini>
                                <el-option v-for="(item,idx) in outdoorProductCategoryOptions" :key="idx"
                                           :value="item.value"
                                           :label="item.label">
                                    {{ item.label }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>
                            <el-select v-model="comprehensiveBusinessRecordSaveForm.borrower" filterable
                                       placeholder="借出人"  size=mini class="w-100">
                                <el-option v-for="(item,idx) in userOptions" :key="idx"
                                           :value="item.value"
                                           :label="item.label">
                                    {{ item.label }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>
                            <el-select v-model="comprehensiveBusinessRecordSaveForm.transportType"
                                       placeholder="运输方式"  size=mini class="w-100" @change="handleTransportChange">
                                <el-option v-for="(item,idx) in transportTypeOptions" :key="idx"
                                           :value="item.value"
                                           :label="item.label">
                                    {{ item.label }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span=8>
                        <el-form-item>
                            <el-date-picker
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    v-model="comprehensiveBusinessRecordSaveForm.leaveFactoryDate"
                                    type="datetime"
                                    placeholder="选择出厂日期" size=mini class="w-100"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span=8>
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.specialRequirement"
                                      placeholder="请输入特殊要求" size=mini></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span=8>
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.outdoorRemark"
                                      placeholder="请输入出门证备注" size=mini></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="运输申请业务数据" v-if="isChooseTransport" label-position=“top”>
                <el-row>
                    <el-form-item v-for="(info,index) in selectedItems" v-if="isFromOrder">
                        <span>{{ info.orderCode }}  </span>
                        <el-select placeholder="请选择工序"
                                   class="el-customer-select"
                                   v-model="selectedOperations[index]"
                                   popper-class="popper-class"
                                   :popper-append-to-body="false"
                                   size=mini multiple filterable>
                            <el-option v-for="(operation,index) in operationOptions[info.id]" multiple="" :key="index"
                                       :value="operation.value"
                                       :label="operation.label">
                                {{ operation.label }}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span=4>
                        <el-form-item>
                            <el-select v-model="comprehensiveBusinessRecordSaveForm.transType" class="w-100"
                                       placeholder="需求类型"  size=mini>
                                <el-option v-for="item in transTypeOptions" :key="item.value" :value="item.value"
                                           :label="item.label">
                                    {{ item.label }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span=4>
                        <el-form-item>
                            <el-select v-model="comprehensiveBusinessRecordSaveForm.requirePackage"
                                       placeholder="需要包装"  size=mini>
                                <el-option v-for="item in booleanOptions" :key="item.value" :value="item.value"
                                           :label="item.label">
                                    {{ item.label }}

                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span=4>
                        <el-form-item>
                            <el-select v-model="comprehensiveBusinessRecordSaveForm.frame"
                                       placeholder="外协框架"  size=mini>
                                <el-option v-for="item in frameOptions" :key="item.value" :value="item.value"
                                           :label="item.label">
                                    {{ item.label }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span=3>
                        <el-form-item>
                            <el-input-number
                                    v-model="comprehensiveBusinessRecordSaveForm.actualTransportQuantity"
                                    placeholder="实际数量" :controls="false" size=mini
                                    length="10"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span=3>
                        <el-form-item>
                            <el-input-number v-model="comprehensiveBusinessRecordSaveForm.actualTransportWeight"
                                             placeholder="实际重量(kg)" :controls="false" size=mini></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span=6>
                        <el-form-item>
                            <el-date-picker
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    v-model="comprehensiveBusinessRecordSaveForm.leaveFactoryDate"
                                    type="datetime"
                                    placeholder="请选择需求运输时间" size=mini class="w-100"></el-date-picker>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row style="flex-wrap:wrap">

                    <el-col :span="8">
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.transReason"
                                      placeholder="请输入运输理由" size=mini @input="changeMessage"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.transportDetailInformation"
                                      placeholder="运输详细信息" size=mini></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item>
                            <el-input v-model="comprehensiveBusinessRecordSaveForm.transportRemark"
                                      placeholder="运输申请备注" size=mini></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="转交物料业务数据" v-if="isChooseDelivery" label-position=“top”>
                <el-select v-model="comprehensiveBusinessRecordSaveForm.deliveryType"
                           placeholder="请选择转交类型"  size=mini :disabled="handleDeliverTypeSelectAble()">
                    <el-option v-for="item in deliveryTypeOptions" :key="item.value" :value="item.value"
                               :label="item.label">
                        {{ item.label }}
                    </el-option>
                </el-select>
                <el-form-item v-if="!isFromOrder && isChooseDelivery">
                    <el-button style="margin-top: 20px" @click="addRow">新增</el-button>
                    <div>
                        <el-table
                                :data="orderNum"
                                style="width: 100%">
                            <el-table-column
                                    prop="projectCode"
                                    label="项目号">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.projectCode" :disabled="!scope.row.editable" size=mini></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="orderCode"
                                    label="工单号">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.orderCode" :disabled="!scope.row.editable" size=mini></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="materialCode"
                                    label="物料号">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.materialCode" :disabled="!scope.row.editable" size=mini ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="materialDesc"
                                    label="物料描述">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.materialDesc" :disabled="!scope.row.editable" size=mini></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="cid"
                                    label="cid">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.cid" :disabled="!scope.row.editable" size=mini ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="weight"
                                    label="重量(kg)">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.sithMesMatSizeAndWeightInfo.weight" :disabled="!scope.row.editable" :controls="false" size=mini ></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="length"
                                    label="长(mm)">
                                <template slot-scope="scope">
                                    <el-input-number  v-model="scope.row.sithMesMatSizeAndWeightInfo.length" :disabled="!scope.row.editable" :controls="false" size=mini></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="width"
                                    label="宽(mm)">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.sithMesMatSizeAndWeightInfo.width" :disabled="!scope.row.editable"  :controls="false" size=mini></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="height"
                                    label="高(mm)">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.sithMesMatSizeAndWeightInfo.height" :disabled="!scope.row.editable" :controls="false" size=mini></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="quantity"
                                    label="数量">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.sithMesMatSizeAndWeightInfo.quantity" :disabled="!scope.row.editable" :controls="false" size=mini></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="unit"
                                    label="单位">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.sithMesMatSizeAndWeightInfo.unit" :disabled="!scope.row.editable" size=mini></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="操作">
                                <template slot-scope="scope">
                                    <div class="btn-group">
                                        <el-button-group>
                                            <el-button @click="editRow(scope.$index)" v-if="!scope.row.editable" size=mini>编辑</el-button>
                                            <el-button type="primary" @click="saveRow(scope.$index)" v-if="scope.row.editable" size=mini>保存</el-button>
                                            <el-button type="danger" icon="el-icon-delete" @click="removeRow(scope.$index)" size=mini>删除</el-button>
                                        </el-button-group>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>

                    </div>
                </el-form-item>
            </el-form-item>
            <el-form-item label="转出票业务数据" v-if="isChooseTransferTicket" label-position=“top”>
                <el-form-item v-for="(info,index) in selectedItems">
                    <span>{{ info.orderCode }}  </span>
                    <el-select placeholder="请选择工序"
                               v-model="selectedOperations[index]"
                               class="el-customer-select"
                               popper-class="popper-class"
                               :popper-append-to-body="false"
                               size=mini multiple filterable>
                        <el-option v-for="(operation,index) in operationOptions[info.id]" multiple="" :key="index"
                                   :value="operation.value"
                                   :label="operation.label">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleComprehensiveBusinessClose()" id="cancel">取 消</el-button>
            <el-tooltip class="item" effect="dark" content="请至少选择一项业务" placement="top"
                        :disabled="!isChooseTransferTicket && !isChooseOutdoor &&!isChooseDelivery &&!isChooseTransport">
                <span>
                    <el-button type="primary" @click="handleComprehensiveBusinessSubmit" id="submit"
                               :disabled="!isChooseTransferTicket && !isChooseOutdoor &&!isChooseDelivery &&!isChooseTransport">确 定
                    </el-button>
                </span>
            </el-tooltip>
        </div>
    </el-dialog>
</template>

<script>
import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    components: {MiniTable},
    mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin],
    name: "comprehensiveBusiness",
    data() {
        return {
            orderNum : [],
            componentOptions: {},
            operationOptions: {},
            supplies: [],
            selectedItemsDeepCopy: [],
            selectedConsignor: null,
            selectedConsignee: null,
            selectedOperations: [],
            selectedComponents: [],
            userOptions: [],
            topMatSizeAndWeightInfo: [],
            comprehensiveBusinessRecordSaveForm: {
                businessTypes: {
                    Type: Number,
                    default: 1,
                },
                orderCodeAndOperationIdsAndComponentInfos: [],
                consignor: '',
                consignorContact: '',
                consignorContactPhone: '',
                consignorAddress: '',
                consignee: '',
                consigneeContact: '',
                consigneeContactPhone: '',
                consigneeAddress: '',
                specialRequirement: '',
                outdoorType: '',
                category: '',
                borrower: '',
                transportType: '',
                leaveFactoryDate: new Date().toISOString().split('T')[0] + ' ' + new Date().toISOString().split('T')[1].split('.')[0],
                outdoorRemark:'',
                transType: '',
                transReason: '',
                requiredTime: '',
                requirePackage: '',
                actualTransportQuantity: undefined,
                actualTransportWeight: undefined,
                frame: '',
                transportFrame: '',
                transportRemark:'',
                transportDetailInformation:'',
                deliveryType: '',
                comprehensiveCommonBusinessInfo: {},
                comprehensiveBusinessInfos:[],
            },
            comprehensiveCommonBusinessInfo: {
                sithMesMatSizeAndWeightInfo: {
                    projectCode: '',
                }
            },
            outdoorProductCategoryOptions: [],
            mstLocationOptions: [],
            outdoorTypeOptions:
                    [
                        {value: '11', label: 'A类-非销售'},
                        {value: '12', label: 'B类-销售产成品'},
                        {value: '13', label: 'C类-销售非产成品'},
                    ],
            booleanOptions:
                    [
                        {value: false, label: '否'},
                        {value: true, label: '是'},
                    ],
            transportTypeOptions:
                    [
                        {value: '1', label: '专车'},
                        {value: '2', label: '零担'},
                        {value: '3', label: '加急零担'},
                        {value: '4', label: '快递'},
                        {value: '5', label: '快递到付'},
                        {value: '6', label: '收货方自提'}
                    ],
            transTypeOptions:
                    [
                        {value: '1', label: '内对外'},
                        {value: '2', label: '内对内'},
                        {value: '3', label: '汽车吊'},
                        {value: '4', label: '外对外'},
                        {value: '5', label: '外对内'}
                    ],
            deliveryTypeOptions:
                    [
                        { value: '2', label: '800工单转交' },
                        { value: '1', label: '生产终检转交' },
                        { value: '4', label: '其他转交' }
                    ],
            frameOptions:
                    [
                        {value: '1', label: '外协框架内'},
                        {value: '2', label: '外协框架外'}
                    ],
            chooseType: [],
            isChooseOutdoor: false,
            isChooseTransport: false,
            isChooseDelivery: false,
            isChooseTransferTicket: false,

        }
    },
    props: {
        selectedItems: [],
        comprehensiveBusinessDialogVisible: {
            type: Boolean,
            default: false,
        },
        isFromOrder: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        businessTypes() {
            let businessType = 1;
            if (this.isChooseOutdoor) {
                businessType *= 2;
            }
            if (this.isChooseTransport) {
                businessType *= 3;
            }
            if (this.isChooseDelivery) {
                businessType *= 5;
            }
            if (this.isChooseTransferTicket) {
                businessType *= 7;
            }
            return businessType;
        },
    },
    watch: {
        comprehensiveBusinessDialogVisible(val) {
            //查询所有供应商
            if (this.supplies.length === 0) {
                let url = this.$store.state.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.baseModuleUrl + "/sithMesInventoryComprehensiveBusinessVendorAndSithInfo/";
                this.$store.dispatch("api/get", {url})
                        .then(data => {
                            data.forEach((item) => {
                                this.supplies.push({
                                    value: item['id'],
                                    chName: item['companyName'],
                                    contact: item['contact'],
                                    contactPhone: item['contactPhone'],
                                    address: item['address']
                                });
                            });
                        });
            }
            if (!val) {
                this.selectedOperations = [];
                this.selectedComponents = [];
                return
            }
            this.comprehensiveBusinessRecordSaveForm.deliveryType = this.deliveryTypeOptions[0].value;
            this.comprehensiveBusinessRecordSaveForm.outdoorType = this.outdoorTypeOptions[0].value;
            //如果不是从工单页面来的，就不查
            if (this.isFromOrder === false) {
                return
            }
            for (let i = 0; i < this.selectedItems.length; i++) {
                this.topMatSizeAndWeightInfo[i] = {}
            }
            let headerIds = this.selectedItems.map(item => item.id).join(",");
            if (headerIds.length === 0) {
                this.$message.warning("请刷新页面后勾选工单");
                return;
            }
            this.selectedItemsDeepCopy = JSON.parse(JSON.stringify(this.selectedItems));
            let bzUrl = `${this.$_emApiMixin_entityBaseApi("sithMesPrdPpComponent")}/findComponentsByHeaderIdList?headerIds=${headerIds}`
            this.$_emApiMixin_post(bzUrl, {}).then(response => {
                if (response.status === 200) {
                    if (response.data instanceof Array) {
                        let options = [];
                        response.data.forEach((item) =>
                                options.push({
                                    orderCode: item['orderNumber'],
                                    value: item['id'],
                                    componentId: item['id'],
                                    materialNumber: item['materialNumber'],
                                    label: item['materialNumber'] + '-' + item['materialDescription'],
                                    sithMesMatSizeAndWeightInfo: {
                                        quantity: item['quantity'],
                                        unit: item['baseUnit'],
                                        weight: item['grossWeight'],
                                    },
                                }))
                        this.componentOptions = {};
                        for (let option of options) {
                            let temp = this.componentOptions[option.orderCode];
                            if (temp && temp.length > 0) {
                                temp.push(option);
                            } else {
                                temp = [option];
                                this.componentOptions[option.orderCode] = temp;
                            }
                        }
                    }
                }
            })
            let operationUrl = `${this.$_emApiMixin_entityBaseApi("sithMesPrdPpOperation")}/findOperationByHeaderIdList?headerIds=${headerIds}`
            this.$_emApiMixin_post(operationUrl, {}).then(response => {
                if (response.status === 200) {
                    if (response.data instanceof Array) {
                        // 按照 age 字段排序：升序（从小到大）
                        const ascCompareFunc = (a, b) => a.operationSeq - b.operationSeq;
                        const sortedPersonListAsc = response.data.slice().sort(ascCompareFunc);
                        let options = [];
                        sortedPersonListAsc.forEach((item) =>
                                options.push({
                                    orderCode: item['orderCode'],
                                    prdPpHeaderId: item['prdPpHeaderId'],
                                    value: item['id'],
                                    label: item['operationSeq'] + '-' + item['operationDescription'],

                                }));
                        this.operationOptions = {};
                        for (let option of options) {
                            let temp = this.operationOptions[option.prdPpHeaderId];
                            if (temp && temp.length > 0) {
                                temp.push(option);
                            } else {
                                temp = [option];
                                this.operationOptions[option.prdPpHeaderId] = temp;
                            }
                        }
                    }
                }
            })
        },
        isChooseOutdoor(val) {
            if (val && this.userOptions.length === 0) {
                let url = `${this.$_emApiMixin_entityBaseApi("emAclUser")}/findByFilter`
                this.$_emApiMixin_post(url, {
                    statusFilter:"1"
                }).then(response => {
                    for (let row of response.data.list) {
                        this.userOptions.push({
                            value: row['name'],
                            label: row['loginName'] + '-' + row['name'],
                        });
                    }}
                )
            }
            //查询所有出门类型
            if (this.outdoorProductCategoryOptions.length === 0) {
                let categoryUrl = this.$store.state.sithMesInventoryOutdoorProductCategory.baseModuleUrl + "/sithMesInventoryOutdoorProductCategory/findByFilter";
                this.$_emApiMixin_post(categoryUrl, {})
                        .then(response => {
                                    for (let row of response.data.list) {
                                        this.outdoorProductCategoryOptions.push({
                                            value: row['id'],
                                            label: row['name'],
                                        });
                                    }
                                }
                        )
            }
        },
        isChooseDelivery(val) {
            if (this.isFromOrder) {
                return;
            }
            if (!val) {
                this.comprehensiveBusinessRecordSaveForm.comprehensiveBusinessInfos = undefined;
            } else {
                this.comprehensiveBusinessRecordSaveForm.comprehensiveBusinessInfos = []
            }
        }
    },
    methods: {
        //清空操作
        removeAll(index) {
            this.selectedComponents[index] = []
            this.$forceUpdate();
        },
        addRow() {
            this.orderNum.push({
                sithMesMatSizeAndWeightInfo :{},
                editable: true
            });
        },
        editRow(index) {
            this.orderNum[index].editable = true;
        },
        saveRow(index) {
            this.orderNum[index].editable = false;
        },
        removeRow(index) {
            this.orderNum.splice(index, 1);
        },
        //全选操作
        selectAll(info,index) {
            this.componentOptions[info.orderCode].map(item => {
                if(!this.selectedComponents[index].some(obj => Object.values(obj).includes(item.componentId))){
                    this.selectedComponents[index].push(item)
                }
            })
            this.$forceUpdate();
        },
        //反选操作
        selectReverse(info,index) {
            let val = [];
            //判断现有选中数据是否包含如果不包含则进行反选数据
            this.componentOptions[info.orderCode].map(item => {
                if (!this.selectedComponents[index].some(obj => Object.values(obj).includes(item.componentId))) {
                    val.push(item)
                }
            })
            this.selectedComponents[index] = val;
            this.$forceUpdate();

        },
        changeMessage() {
            this.$forceUpdate();
        },
        handleConsignorChange() {
            this.comprehensiveBusinessRecordSaveForm.consignor = this.selectedConsignor.chName;
            this.comprehensiveBusinessRecordSaveForm.consignorContact = this.selectedConsignor.contact;
            this.comprehensiveBusinessRecordSaveForm.consignorContactPhone = this.selectedConsignor.contactPhone;
            this.comprehensiveBusinessRecordSaveForm.consignorAddress = this.selectedConsignor.address;
        },
        handleConsigneeChange() {
            this.comprehensiveBusinessRecordSaveForm.consignee = this.selectedConsignee.chName;
            this.comprehensiveBusinessRecordSaveForm.consigneeContact = this.selectedConsignee.contact;
            this.comprehensiveBusinessRecordSaveForm.consigneeContactPhone = this.selectedConsignee.contactPhone;
            this.comprehensiveBusinessRecordSaveForm.consigneeAddress = this.selectedConsignee.address;
        },
        handleComprehensiveBusinessSubmit() {
            // 选择了出门证和运输申请才校验
            if (this.comprehensiveBusinessRecordSaveForm.leaveFactoryDate === undefined && (this.isChooseOutdoor || this.isChooseTransport)) {
                this.$message.error("请选择出厂时间或者需求运输时间");
                return;
            }
            let submit = document.getElementById("submit");
            this.comprehensiveBusinessRecordSaveForm.businessTypes = this.businessTypes;
            this.comprehensiveBusinessRecordSaveForm.requiredTime = this.comprehensiveBusinessRecordSaveForm.leaveFactoryDate;
            let bzUrl = ''
            if (this.isFromOrder) {
                bzUrl = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryComprehensiveBusinessRecord")}/generateComprehensiveBusinessRecordByOrderCode`
                for (let i = 0; i < this.selectedItems.length; i++) {
                    let orderCode = this.selectedItems[i]['orderCode'];
                    // 选择了非转交业务才校验
                    if ((this.selectedOperations[i] === undefined || this.selectedOperations[i].length === 0)
                            && (this.isChooseOutdoor || this.isChooseTransport || this.isChooseTransferTicket)) {
                        this.$message.error("请给所有的工单先选择工序后提交！");
                        this.comprehensiveBusinessRecordSaveForm.orderCodeAndOperationIdsAndComponentInfos = [];
                        return;
                    }
                    if (this.topMatSizeAndWeightInfo[i] == null && this.selectedComponents[i].length === 0) {
                        this.$message.error("请给所有的工单勾选顶极物料或者选择工单的组件！");
                        this.comprehensiveBusinessRecordSaveForm.orderCodeAndOperationIdsAndComponentInfos = [];
                        return;
                    }
                    this.comprehensiveBusinessRecordSaveForm.orderCodeAndOperationIdsAndComponentInfos.push({
                        orderCode: orderCode,
                        sithMesMatSizeAndWeightInfo: this.topMatSizeAndWeightInfo[i],
                        operationIds: this.selectedOperations[i],
                        componentInfos: this.selectedComponents[i]
                    });
                }
            } else {
                bzUrl = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryComprehensiveBusinessRecord")}/generateComprehensiveBusinessRecord`
                this.comprehensiveBusinessRecordSaveForm.comprehensiveBusinessInfos = this.orderNum;
                this.comprehensiveBusinessRecordSaveForm.comprehensiveCommonBusinessInfo = this.comprehensiveCommonBusinessInfo;
            }
            submit.disabled = true;
            this.$message.success("综合业务申请中，请等待结果");
            this.$_emApiMixin_post(bzUrl, this.comprehensiveBusinessRecordSaveForm).then(response => {
                if (response.status === 200) {
                    this.$message.success("综合业务申请成功");
                    this.handleComprehensiveBusinessClose();
                } else {
                    this.$message.error(response.message);
                    submit.disabled = false;
                }
            })
        },
        handleComprehensiveBusinessClose() {
            this.comprehensiveBusinessRecordSaveForm ={};
            this.comprehensiveBusinessRecordSaveForm.orderCodeAndOperationIdsAndComponentInfos = [];
            this.comprehensiveBusinessRecordSaveForm.comprehensiveBusinessInfos = [];
            this.comprehensiveCommonBusinessInfo = {
                sithMesMatSizeAndWeightInfo: {}
            };
            this.componentOptions = {};
            this.operationOptions = {};
            this.selectedComponents = [];
            this.selectedOperations = [];
            this.topMatSizeAndWeightInfo = [];
            this.isChooseTransferTicket = false;
            this.isChooseTransport = false;
            this.isChooseOutdoor = false;
            this.isChooseDelivery = false;
            this.selectedConsignor = null;
            this.selectedConsignee = null;
            this.orderNum = [];
            this.$emit("change");
        },
        //切换顶级物料和次级物料清除对应的表单
        handleMatCheckboxChange(index, info) {
            if (info.checked) {
                this.topMatSizeAndWeightInfo[index] = {
                    quantity: info.targetQuantity,
                    unit: 'PC'
                };
                this.selectedComponents[index] = null;
            } else {
                this.topMatSizeAndWeightInfo[index] = null;
                this.selectedComponents[index] = [];
            }
        },
        deleteItem() {
            this.orderNum.splice(-1, 1);
        },
        addItem() {
            this.orderNum.push({
                sithMesMatSizeAndWeightInfo: {}
            });
        },
        handleTransportChange() {
            this.transportTypeOptions.forEach((item) => {
                if (item.value === this.comprehensiveBusinessRecordSaveForm.transportType) {
                    this.comprehensiveBusinessRecordSaveForm.transReason = item.label;
                }
            });
        },
        handleDeliverTypeSelectAble() {
            return this.isFromOrder
        }
    }
};
</script>
<style scoped>
.el-form-item__content .el-input-number--mini {
    width: 100% !important;
    flex-wrap: wrap;
}
.el-form-item {
    margin-left: 1rem;
}
.el-customer-select{
    width:30rem;
}
::v-deep .popper-class {
    max-width: 30rem;
}
.iclass-text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.btn-group {
    display: flex;
    align-items: center;
}
.btn-group > .el-button {
    margin-right: 5px; /* 调整按钮之间的间距 */
}
.el-table thead th, .el-table tbody td {
    text-align: center;
}
</style>

